<template>
  <a-card :bordered="false">
    
    <!-- 上部订单查询 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24" style="float:left">
            <a-form-item label="客户名称">
              <a-select showSearch v-model="queryParam.businessId" style="max-width: 320px" :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option v-for="(item, index) in businessSelect" :key="index" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="物料名称">
              <a-select showSearch v-model="queryParam.materielId"  style="max-width: 320px"
                :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option v-for="(item, index) in materielSelect" :key="index" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="5" :sm="24">
            <a-form-item label="合同号">
              <a-input v-model.trim="queryParam.contractNo" placeholder="" />
            </a-form-item>
          </a-col>

          <a-col :md="5" :sm="24" style="float:right"> 
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="refreshData">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>

          <a-col :md="8" :sm="24">
            <a-form-item label="订单状态">
              <a-select showSearch v-model="queryParam.status"  style="max-width: 320px"
                :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option v-for="(item, index) in orderStatusList" :key="index" :value="item.value">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="14" :sm="24">
              <a-form-item label="查询日期">
                <a-date-picker
                  format="YYYY-MM-DD"
                  v-model="queryParam.startDate"
                  placeholder=""
                  :disabledDate="disabledDate"
                />
                至
                <a-date-picker
                  format="YYYY-MM-DD"
                  v-model="queryParam.endDate"
                  placeholder=""
                  :disabledDate="disabledDate"
                />
              </a-form-item>
            </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" v-if="roleId === config.RoleType.SALE_MAN">
      <a-button type="primary" icon="plus" @click="addOrder()">创建订单</a-button>
      <a-button v-if='roleId === config.RoleType.SALE_MAN && selectRow && selectRow.status !== config.OrderStatus.CANCELED' type="primary" icon="plus" @click="addDetails()" style="margin-left:20px;">添加子订单</a-button>
    </div>

    <!-- 订单列表 -->
    <s-table ref="table" :pageSize="pageSize" size="small" :bordered="config.globlaBordered" :rowKey="(record) => record.id"
      :columns="columns" :data="loadData" :scroll="{ x: 1500,y:600}" 
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange,hideDefaultSelections:hideDefaultSelections,type:'radio' }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}">

      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record" v-if="record.status !== config.OrderStatus.CANCELED">
        <a v-if='roleId === config.RoleType.SALE_MAN && !record.hasValidChildren' @click="editorOrder(record)">编辑</a>
   
 <!--        <a-divider type="vertical" v-if='roleId === config.RoleType.SALE_MAN'/>
        <a v-if='roleId === config.RoleType.SALE_MAN' @click="cancelOrder(record)" >作废</a></a-menu-item> -->
      </span>

      <span slot="status" slot-scope="text, record, index">
        {{record.status !== config.OrderStatus.CANCELED?"否":"是"}}
        <span class="blacktr" v-if='record.status === config.OrderStatus.CANCELED'></span>
        <span class="removeblacktr" v-if='record.status !== config.OrderStatus.CANCELED'></span>
      </span>
    </s-table>


      <!-- 子订单列表 -->
      <a-table ref="table2" size="small" :bordered="config.globlaBordered" :rowKey="(record) => record.id"
        :columns="detailsColumns" :dataSource="detailsList" :scroll="{ x: 2650}" 
        :pagination="false">
  
        <span slot="detailsStatus" slot-scope="text, record, index">
          {{ getTextByOrderStatus(record.status)}}
          <span class="sub_blacktr" v-if='record.status === config.OrderStatus.CANCELED'></span>
          <span class="sub_removeblacktr" v-if='record.status !== config.OrderStatus.CANCELED'></span>
        </span> 

        <template slot="orderOperation" slot-scope="text, record, index" >
        <span v-if="record.status !== config.OrderStatus.CANCELED">
           <!--  <a v-if='record.status === config.OrderStatus.WAIT_AUDIT && roleId === config.RoleType.FINANCE' @click="auditOrder(record)" >审核</a> -->
<!--            <a v-if='record.status === config.OrderStatus.WAIT_AUDIT' @click="auditOrder(record, config.OrderStatus.XS_AUDITED)" >审核</a> -->
           <a v-if='record.status === config.OrderStatus.WAIT_AUDIT && roleId === config.RoleType.FINANCE' @click="auditOrder(record, config.OrderStatus.AUDITED)" >审核</a>
           <template v-if='record.status !== config.OrderStatus.WAIT_AUDIT && record.status !== config.OrderStatus.AUDITED && roleId === config.RoleType.SALE_MAN'>
              <a @click="editDetails(record)">编辑</a>
              <a-divider type="vertical" />
              <a @click="cancelDetails(record)">作废</a>
            </template>
            <a v-if='record.status === config.OrderStatus.AUDITED && roleId === config.RoleType.SALE_MAN' @click="changeDetailsStatus(record)">关闭</a>
         </span> 
        </template>
      </a-table>
    <!-- 订单添加和修改 -->
    <a-modal
      title="操作"
      style="top: 10px;"
      :width="640"
      :confirmLoading="showLoading"
      v-model="visible.order"
      :maskClosable="config.globlaMaskClosable"
      @ok="saveOrderXs"
      destroyOnClose
    >
      <a-form :form="orderForm">
<!--           <a-form-item label="订单号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-input
              :disabled="disabled"
              placeholder=""
              v-decorator="['orderNo', { initialValue: orderMdl.orderNo, rules: [{ required: true, message: '请输入订单号'}]}]"
            />
          </a-form-item> -->

        <a-form-item label="客户名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            :disabled="disabledBizId"
            showSearch
            :filterOption="filterOption"
            placeholder="客户名称"
            v-decorator="['businessId',
            { initialValue: orderMdl.businessId, rules: [{ required: true, message: '请选择客户名称'}]}]"
          >
            <a-select-option
              v-for="(item, index) in businessSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="合同编号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            placeholder=""
            v-decorator="['contractNo', { initialValue: orderMdl.contractNo, rules: [{ required: true, message: '请输入合同编号'}]}]"
          />
        </a-form-item>

        <a-form-item label="合同金额" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number suffix="元"  :disabled="disabledContractAmount" :min="0" :max="10000000000" :precision="precision" style="width: 296px;"   
            v-decorator="['contractAmount', { initialValue: orderMdl.contractAmount, rules: [{ required: true, message: '请输入合同金额'}]}]" />
        </a-form-item>

        <a-form-item label="付款方式" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            placeholder="付款方式"
            @change="changePaymentType"
            v-decorator="['paymentType',
            { initialValue: orderMdl.paymentType, rules: [{ required: true, message: '请选择付款方式'}]}]"
          >
            <a-select-option
              v-for="(item, index) in config.paymentTypeList"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

      <!--   <a-form-item label="有效日期" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
              <a-date-picker 
                :disabledDate="disabledDate"
                style="max-width: 130px"
                v-decorator="['beginTime', { initialValue: orderMdl.beginTime, rules: [{ required: false, message: '请选择生效日期'}]}]"
                placeholder="生效日期" />
                至
                <a-date-picker 
                :disabledDate="disabledDate"
                style="max-width: 130px"
                v-decorator="['endTime', { initialValue: orderMdl.endTime, rules: [{ required: false, message: '请选择失效日期'}]}]"
                placeholder="失效日期" />
          </a-form-item>
 -->
         <!--  <a-form-item label="送货方式" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-radio-group v-decorator="['isTransport', { initialValue: orderMdl.isTransport, rules: [{ required: true, message: '请选择是否承运'}]}]">
                <a-radio value="1">配送</a-radio>
                <a-radio value="0">自提</a-radio>
              </a-radio-group>
          </a-form-item> -->
      </a-form>
    </a-modal>

    <!-- 子订单添加和修改 -->
    <a-modal title="操作" :maskClosable="config.globlaMaskClosable" :footer="footerData" style="top: 10px;" :width="640" :confirmLoading="showLoading" v-model="visible.details"
      destroyOnClose>

      <a-form :form="detailsForm">
   
        <a-form-item label="订单号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input :disabled="disabled" placeholder=""
            v-decorator="['orderNo', { initialValue: detailsMdl.orderNo, rules: [{ required: true, message: '请输入订单号'}]}]" />
        </a-form-item>
        
  <!--       <a-form-item label="订单行号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-input :disabled="disabled" placeholder=""
              v-decorator="['code', { initialValue: detailsMdl.code, rules: [{ required: true, message: '请输入订单行号'}]}]" />
          </a-form-item> -->

        <a-form-item label="物料名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select showSearch :filterOption="filterOption" placeholder="请选择"
          v-decorator="['materielId', { initialValue: detailsMdl.materielId, rules: [{ required: true, message: '请选择物料'}]}]" >
            <a-select-option v-for="(item, index) in materielSelect" :key="index" :value="item.id">{{item.name}}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="订单量" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-input-number suffix="KG"  @change="(value) => changeOrderNumber(value)" :min="0" :precision="precision" style="width: 296px;"   
            v-decorator="['orderNum', { initialValue: detailsMdl.orderNum, rules: [{ required: true, message: '请输入订单量'}]}]" />
        </a-form-item>

        <a-form-item label="订单单价" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number @change="(value) => changeOrderPrice(value)" :min="0" :max="10000000000" :precision="precision" style="width: 296px;" 
          v-decorator="['price', { initialValue: detailsMdl.price, rules: [{ required: true, message: '请输入订单单价'}]}]" />
       </a-form-item>

       <a-form-item label="订单金额" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number  :disabled="disabled" :min="0" :precision="precision" style="width: 296px;"   
          v-decorator="['amount', { initialValue: detailsMdl.amount, rules: [{ required: true, message: '请输入订单金额'}]}]" />
      </a-form-item>

      <a-form-item label="可用金额" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number  :disabled="disabled" :min="0" :precision="precision" style="width: 296px;"   
          v-decorator="['availableBalance', { initialValue: detailsMdl.availableBalance, rules: [{ required: true, message: '请输入可用余额'}]}]" />
      </a-form-item>

       <a-form-item label="是否承运" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
        <a-radio-group  @change="onRadioChangeIsTransport" v-decorator="['isTransport', { initialValue: detailsMdl.isTransport, rules: [{ required: true, message: '请选择送货方式'}]}]">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="运输方式" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            placeholder="运输方式"
            v-decorator="['transportType',
            { initialValue: detailsMdl.transportType, rules: [{ required: true, message: '请选择运输方式'}]}]"
          >
            <a-select-option
              v-for="(item, index) in config.transportTypeList"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="运输地址" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input  placeholder=""
          v-decorator="['transportAddress', { initialValue: detailsMdl.transportAddress, rules: [{ required: addressRequired, message: '请输入运输地址'}]}]" />
        </a-form-item>

        <a-form-item label="联系方式" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input  placeholder=""
          v-decorator="['contact', { initialValue: detailsMdl.contact, rules: [{ required: true, message: '请输入联系方式'}]}]" />
        </a-form-item>

        <a-form-item label="联系人" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input  placeholder=""
          v-decorator="['contactor', { initialValue: detailsMdl.contactor, rules: [{ required: false, message: '请输入联系人'}]}]" />
        </a-form-item>

        <a-form-item label="交货日期" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-date-picker
                style="width: 296px"
                format="YYYY-MM-DD"
                placeholder=""
                :disabledDate="disabledDateAfterToday"
                v-decorator="['deliveryDate',
                { initialValue: detailsMdl.deliveryDate, rules: [{ required: false, message: '请选择交货日期'}]}]"
              />
        </a-form-item>

        <a-form-item label="备注" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input  placeholder=""
          v-decorator="['memo', { initialValue: detailsMdl.memo, rules: [{ required: false, message: '请输入备注'}]}]" />
        </a-form-item>
    </a-form>
    </a-modal>

    <a-modal
        title="订单审核"
        style="top: 100px;"
        :width="300"
        v-model="visible.audit"
        @ok="auditOk"
        :confirmLoading="showLoading"
      >
        <a-row style="text-align:center;">
          <a-radio-group v-model="auditStatus" buttonStyle="solid" @change="onRadioChange">
            <a-radio-button :value="item.value" v-for="item in auditStatusList" >{{item.name}}</a-radio-button>
           <!--  <a-radio-button value="3">不通过</a-radio-button> -->
          </a-radio-group>
        </a-row>

        <a-row style="text-align:center;margin-top:10px;" v-show="reasonShow">
            <a-input  placeholder="请输入不通过原因"  v-model="reason"/>
        </a-row>
  <!--       <a-col :md="20" style="margin-top:10px;margin-bottom:10px;">
          <a-input :rows="1"  placeholder="..." id="describe" 
          v-decorator="['remark',
          { initialValue: remark, rules: [{ required: true, message: '请输入原因'}]}]"/>
        </a-col> -->
     <!--    <a-row :gutter="48" v-if="auditResStatus == '3'"> 
          <a-col :md="3" class="textright">说明：</a-col>
          <a-col :md="21">
            <a-textarea :rows="1"  placeholder="..." id="describe" 
            v-decorator="['remark',
            { initialValue: remark, rules: [{ required: true, message: '请输入原因'}]}]"/>
          </a-col>
       </a-row>  -->
    </a-modal>

  </a-card>
</template>

<script>
  import { STable } from '@/components'
  import { findListByBusinessTypeId, corpBusinessList} from '@/api/basic'
  import { xsOrderPage, genXsOrderNo,saveOrderXs, cancelOrderXs,changeDetailsStatus,auditOrderDetailsXs, saveXsDetails, cancelXsDetails,getXsOrderBalance } from '@/api/order'
  import moment from 'moment'
  import { formatDate } from '../../utils/date.js'
  import Bus from '@/layouts/bus'
  import queryMixin from '@/mixins/queryMixin'

  export default {
    name: 'OrderList',
    mixins: [queryMixin],
    components: {
      STable
    },
    data() {
      return {
        // pageSizeOptionsList: ['5','10','20'],
        pageSizeOptionsList: ['5'],
        pageSize: 5,
        materielSelect: null,
        businessSelect: [],
        description:
          '销售订单管理',
        visible: {
          order:false,
          details:false,
          audit:false
        },
        orderStatusList: this.config.orderStatusList.slice(0,8),

        orderForm: this.$form.createForm(this),
        detailsForm: this.$form.createForm(this),

        orderMdl:{},
        detailsMdl:{},

        disabled: true,
        disabledBizId:false,
        disabledContractAmount:false,

        defaultTransport:'0',
        defaultDate: moment(new Date(), 'YYYY-MM-DD'),
        defaultNum: 0.00,
        defaultTransportType: this.config.TransportType.vehicle,

        precision:2,

        roleId: null,
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {businessId:null, startDate:moment().startOf('month'), endDate:moment(new Date(), 'YYYY-MM-DD')},

        loading: false,
        showLoading: false,

        orderList: [],
        orderDetailsXsList: [],

        selectMaterielId:null,
        selectMaterielName:null,
        auditStatus:this.config.OrderStatus.XS_AUDITED,
        auditStatusList:[],
        xsAuditStatusList:[{value:this.config.OrderStatus.XS_AUDITED,name:'通过'},{value:this.config.OrderStatus.XS_REFUSE, name:'不通过'}],
        cwAditStatusList:[{value:this.config.OrderStatus.AUDITED,name:'通过'},{value:this.config.OrderStatus.REFUSE, name:'不通过'}],
        reason:'',
        reasonShow:false,
        auditId: null,
        auditOrderNo: null,

        data: [],
        addressRequired: false,
        hideDefaultSelections: true,
        detailsList: [],
        materielGroupIds:'',

        footerData:[
        <button type="button" class="ant-btn ant-btn-default" onClick={this.doCancelDetails}><span>取 消</span></button>,
        //<button type="button" class="ant-btn ant-btn-primary" onClick={this.saveDetails}><span>保存</span></button>,
        <button type="button" class="ant-btn ant-btn-primary" onClick={this.submitDetails}><span>提交</span></button>],
        // 表头
        columns:[],
        allColumns: [
   /*        {
            title: '#',
            scopedSlots: { customRender: 'serial' }
          }, */
          {
            title: '合同编号',
            dataIndex: 'contractNo',
            width: '180px'
          },
            {
            title: '合同金额',
            dataIndex: 'contractAmount',
            width: '100px'
          },

          {
            title: '客户名称',
            dataIndex: 'businessName',
            /*  width: '140px' */
          },
          {
            title: '订单号',
            dataIndex: 'orderNo',
            width: '170px'
          },
          {
            title: '付款方式',
            dataIndex: 'paymentType',
            width: '80px',
            customRender: text => {
              if (text) {
             /*    for (var i=0; i<this.config.paymentTypeList.length;i++){
                  let payment = this.config.paymentTypeList[i]
                  if (text === payment.value){
                      return payment.name
                  }
                } */

                let res = this.config.paymentTypeList.filter((item) => {
                  return text === item.value;
                });
                return res[0].name
              }
            }
          },
         /*  {
            title: '部门',
            dataIndex: 'department',
            width: '80px'
          },
          {
            title: '销售区域',
            dataIndex: 'area',
            width: '100px'
          },
          {
            title: '业务员',
            dataIndex: 'salesman',
            width: '80px'
          }, */
      /*     {
            title: '生效日期',
            dataIndex: 'beginTime',
            width: '100px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd')
              }
            }
          },
          {
            title: '失效日期',
            dataIndex: 'endTime',
            width: '100px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd')
              }
            }
          }, */
        /*   {
            title: '审核人',
            dataIndex: 'auditor',
            width: '80px'
          },
          {
            title: '审核时间',
            dataIndex: 'auditTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          }, */
          {
            title: '创建人',
            dataIndex: 'createId',
            width: '80px',
            customRender: (text, row, index) => {
              if (!text) return "";
              let userList = this.$store.getters.userList;
              return userList[text];
            }
          },
          {
            title: '是否作废',
            width: '80px',
            scopedSlots: { customRender: 'status' },
          }, 
          {
            title: '作废人',
            dataIndex: 'cancelId',
            width: '80px',
            customRender: (text, row, index) => {
              if (!text) return "";
              let userList = this.$store.getters.userList;
              return userList[text];
            }
          },
          {
            title: '作废时间',
            dataIndex: 'cancelTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
          {
            title: '操作',
            width: '150px',
            dataIndex: 'action',
            fixed: 'right',
            scopedSlots: { customRender: 'action' }
          }
        ],
        detailsColumns:[],
        allDetailsColumns: [
          {
            title: '订单行号',
            dataIndex: 'code',
            width: '80px',
          },
          {
            title: '物料名称',
            dataIndex: 'materielName',
            /*    width: '80px',  */
          },
          {
            title: '订单量(吨)',
            dataIndex: 'orderNum',
            width: '90px',
          },
          {

            title: '发货量(吨)',
            dataIndex: 'scaleNum',
            width: '90px',
          },
          {

            title: '剩余量(吨)',
            dataIndex: 'remainNum',
            width: '90px',
          },
          {
            title: '订单单价',
            dataIndex: 'price',
            width: '90px',
          },
          {
            title: '订单金额',
            dataIndex: 'amount',
            width: '90px',
          },
          {
            title: '订单状态',
            dataIndex: 'status',
            width: '80px',
            scopedSlots: { customRender: 'detailsStatus' },
          },
          {
            title: '是否承运',
            dataIndex: 'isTransport',
            width: '80px',
            customRender: (text, record) => {
              if (text === '1') {
                return '是'
              }
              return '否'
            }
          },
/*           {
            title: '提货地点',
            dataIndex: 'storeName',
            width: '90px',
          }, */
          {
            title: '运输方式',
            dataIndex: 'transportType',
            width: '90px',
            customRender: text => {
              if (text) {
                for (var i=0; i<this.config.transportTypeList.length;i++){
                  let transportType = this.config.transportTypeList[i]
                  if (text === transportType.value){
                      return transportType.name
                  }
                } 
              }
            }
          },
          {
            title: '运输地址',
            dataIndex: 'transportAddress',
            width: '200px',
          },
          {
            title: '联系方式',
            dataIndex: 'contact',
            width: '120px',
          },
          {
            title: '联系人',
            dataIndex: 'contactor',
            width: '80px',
          },
          {
            title: '交货日期',
            dataIndex: 'deliveryDate',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd')
              }
            }
          },
          {
            title: '创建人',
            dataIndex: 'createId',
            width: '80px',
            customRender: (text, row, index) => {
              if (!text) return "";
              let userList = this.$store.getters.userList;
              return userList[text];
            }
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
          {
            title: '备注',
            dataIndex: 'memo',
            width: '120px',
          },
          {
            title: '审核人',
            dataIndex: 'auditId',
            width: '80px',
            customRender: (text, row, index) => {
              if (!text) return "";
              let userList = this.$store.getters.userList;
              return userList[text];
            }
          },
          {
            title: '审核时间',
            dataIndex: 'auditTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          }, 
          {
            title: '不通过原因',
            dataIndex: 'reason',
            width: '100px'
          },
          {
            title: '作废人',
            dataIndex: 'cancelId',
            width: '120px',
            customRender: (text, row, index) => {
              if (!text) return "";
              let userList = this.$store.getters.userList;
              return userList[text];
            }
          },
          {
            title: '作废时间',
            dataIndex: 'cancelTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
          {
            title: '操作',
            key: 'orderOperation',
            fixed: 'right',
            scopedSlots: { customRender: 'orderOperation' },
            width: '120px',
          }
        ],
       
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          //this.queryParam.pageSize = 5

          if (this.queryParam.startDate > this.queryParam.endDate){
            this.$message.warning('开始日期不能大于结束日期',3)
            return
          }
          let condition = Object.assign(parameter, this.queryParam)
          if (condition.startDate){
            condition.startDate = formatDate(new Date(condition.startDate), 'yyyy-MM-dd')
          }
          if (condition.endDate){
            condition.endDate = formatDate(new Date(condition.endDate), 'yyyy-MM-dd')
          }
          return xsOrderPage(condition).then(res => {
             setTimeout(() => {
                $('.blacktr').parents('tr').css("background-color", "#cf3659")
                $('.removeblacktr').parents('tr').css("background-color","#fff")
              }, 1000); 
            return res.data
          })
        },

        selectedRowKeys: [],
        selectedRows: [],
        selectRow:null,
        options: {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },
        optionAlertShow: true
      }
    },
    created() {
      //this.loadData({})
      this.loadSelect()
      // 初始化查询条件
      this.queryParam = this.queryParam || null
      this.roleId = this.$store.getters.roles
      this.materielGroupIds = this.$store.getters.materielGroupIds
      // 调运部不允许查看合同金额、订单单价、订单金额
      if (this.config.RoleType.DISPATCH === this.roleId){
        this.setColumns()
      }else{
        this.columns = this.allColumns
        this.detailsColumns = this.allDetailsColumns
      }

    },

    mounted(){
    },
    methods: {
      moment,

      loadSelect() {
        new Promise(resolve => {
          const data = findListByBusinessTypeId({"businessTypeId":101}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.materielSelect = res
        }),
        new Promise(resolve => {
            const data = corpBusinessList({}).then(res => {
              return res.data
            })
            resolve(data)
          }).then(res => {
            this.businessSelect = res
          /*   if (this.businessSelect && this.businessSelect.length > 0){
              this.queryParam.businessId =  this.businessSelect[0].id
            } */
        })
      },
      disabledDate(current) {
        return current && current > moment().endOf('day')
      },
      disabledDateAfterToday(current) {
        return current && current < moment().subtract(1, "days")
      },
 
      setColumns(){
        let newColumns = []
        this.allColumns.forEach(obj=>{
          if (obj.dataIndex !== 'contractAmount'){
            newColumns.push(obj)
          }
        })
        this.columns = newColumns 

        let newDetailsColumns = []
        this.allDetailsColumns.forEach(obj=>{
          if (obj.dataIndex !== 'price' && obj.dataIndex !== 'amount'){
            newDetailsColumns.push(obj)
          }
        })
        this.detailsColumns = newDetailsColumns 
      },
      changePaymentType (value){
        if (value === '框架合同'){
          // this.$set(this.orderMdl, 'contractAmount', 0) 
          this.orderForm.setFieldsValue({"contractAmount": 0})
          this.disabledContractAmount = true
        }else{
          this.disabledContractAmount = false
        }
      },
      refreshData(){
        this.$refs.table.refresh()
        this.selectedRowKeys = []
        this.selectedRows = []
        this.selectRow = null
        this.detailsList = []
      },
      onRadioChangeIsTransport(e){
        let isTransport = e.target.value 
        this.addressRequired = isTransport === "1" ? true : false
      },

      onRadioChange(e){
        if (e.target.value === this.config.OrderStatus.XS_REFUSE || e.target.value === this.config.OrderStatus.REFUSE){
          this.reasonShow = true
        }else{
          this.reasonShow = false
        }
      },
      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectRow = selectedRows[0]
        this.detailsList = this.selectRow.orderDetailsXsList
        if (this.detailsList.length > 0){
          setTimeout(() => {
            $('.sub_blacktr').parent().parent().parent('tr').css("background-color", "#cf3659")
            $('.sub_removeblacktr').parent().parent().parent('tr').css("background-color","#fff")
          }, 100); 
        }
      },
      expand(expanded, record){
        if (!expanded){
          return
        }
        setTimeout(() => {
          let num = record.orderDetailsXsList.length
          let height = 86 + 38 * num
          console.log($('.ant-table-expanded-row').length)
          $('tr[data-row-key='+record.id+'-extra-row]').css("height", height)
        }, 10); 
      },
      getTextByOrderStatus(status){
        for (let i=0; i< this.config.orderStatusList.length; i++){
          let orderStatus = this.config.orderStatusList[i]
          if (orderStatus.value === status ){
            return orderStatus.name
          }
        }
      },

      addOrder() {
        this.orderMdl = {}
        this.orderForm = this.$form.createForm(this)
        this.visible.order = true
        this.disabledBizId = false
      },

      editorOrder(record) {
        this.orderMdl = Object.assign({}, record)
        this.orderForm = this.$form.createForm(this)
        // 编辑禁止修改客户
        this.disabledBizId = true
        this.visible.order = true
      },

      saveOrderXs() {
        this.orderForm.validateFields((err, values) => {
          if (!err) {
            Object.assign(this.orderMdl, values)
            this.showLoading = true
            saveOrderXs(Object.assign({}, this.orderMdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible.order = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(res => {
                this.showLoading = false
              })
          }
        })
      },

      auditOk() {
        let that = this
        let msg = "审核通过"
        if ( !(this.auditStatus === this.config.OrderStatus.XS_AUDITED || this.auditStatus === this.config.OrderStatus.AUDITED)) {
          msg = "审核不通过"   
        }
        that.$confirm({
          title: '提示',
          content: '确定'+msg+'吗?',
          onOk() {
            that.confirmLoading = true
            return auditOrderDetailsXs({id: that.auditId, auditStatus:that.auditStatus,orderNo:that.auditOrderNo, reason:that.reason, queryStatus:that.queryParam.status})
              .then(res => {
                if (res.code === '0') {
                  that.visible.audit = false
                  //that.$refs.table.refresh()
                  that.detailsList = res.data
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                that.confirmLoading = false
              })
          },
          onCancel() { }
        }) 
      },

      auditOrder(record, auditStatus) {
        this.auditId = record.id
        this.auditOrderNo = record.orderNo
        this.visible.audit = true
        this.auditStatus = auditStatus
        if (auditStatus === this.config.OrderStatus.XS_AUDITED){
          this.auditStatusList = this.xsAuditStatusList
        }
        if (auditStatus === this.config.OrderStatus.AUDITED){
          this.auditStatusList = this.cwAditStatusList
        }
      },
      
      cancelOrder(record) {
        var that = this
        this.$confirm({
          title: '提示',
          content: '会同时作废所有子订单，确定要作废吗?',
          onOk() {
            that.confirmLoading = true
            return cancelOrderXs({id:record.id})
              .then(res => {
                if (res.code === '0') {
                  that.refreshData()
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                that.confirmLoading = false
              })
          },
          onCancel() { }
        })
      },

      changeOrderNumber(value) {
        value = parseFloat(value);
        if (!value || isNaN(value)){
          // value = 0;
          return;
        }
   /*      let remainNum = Number(value) - Number(this.detailsMdl.scaleNum || 0)
        this.$set(this.detailsMdl, 'remainNum', remainNum) */
        let price = this.detailsForm.getFieldValue('price');
        if (price &&  Number(price) > 0){
          let amount = Number(value) * Number(price)
          this.$set(this.detailsMdl, 'amount', amount) 
        }
      },
      
      changeOrderPrice(value) {
        value = parseFloat(value);
        if (!value || isNaN(value)){
          // value = 0;
          return;
        }
        let orderNum = this.detailsForm.getFieldValue('orderNum');
        if (orderNum &&  Number(orderNum) > 0){
          let amount = Number(value) * Number(orderNum)
          this.$set(this.detailsMdl, 'amount', amount) 
        }
      },

      addDetails() {
        if (!this.selectRow){
          this.$message.warning('请勾选要操作的主订单!',3)
          return
        }
        let record = this.selectRow
        this.detailsMdl = {scaleNum:this.defaultNum, remainNum:this.defaultNum, orderNo:record.orderNo, isTransport: this.defaultTransport, transportType: this.defaultTransportType}
        this.detailsForm = this.$form.createForm(this)
        this.visible.details = true

        let detailsList = record.orderDetailsXsList
        let length = detailsList.length
        this.detailsMdl.code = length > 0 ? "00"+(parseInt(detailsList[length - 1].code) + 1).toString() : "001"
        this.getBalance(record.businessId)

        this.addressRequired = this.defaultTransport === "1" ? true : false

         setTimeout(() => {
           let $orderNum =  $('#orderNum')
           let $price =  $('#price')
           $orderNum.find('.ant-input-number-input-wrap').append('<span class="wxf-input-suffix">吨</span>')
           $price.find('.ant-input-number-input-wrap').append('<span class="wxf-input-suffix">吨/元</span>')
          }, 100); 
      },

      getBalance(businessId,excludeDetailsId){
        getXsOrderBalance({'businessId': businessId,'excludeDetailsId': excludeDetailsId})
          .then(res => {
            if (res.code === '0') {
              this.$set(this.detailsMdl, 'availableBalance', res.data)
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
 
      editDetails(record) {
        let businessId = this.selectRow.businessId
        this.detailsMdl = Object.assign({}, record)
        this.detailsForm = this.$form.createForm(this)
        this.visible.details = true
        this.detailsMdl.orderNo = record.orderNo
        if (this.detailsMdl.deliveryDate){
          this.detailsMdl.deliveryDate = moment(record.deliveryDate)
        }
        this.getBalance(businessId, record.id)

        this.addressRequired = this.detailsMdl.isTransport === "1" ? true : false
      },

      cancelDetails(record) {
        var that = this
        this.$confirm({
          title: '提示',
          content: '确定要作废吗?',
          onOk() {
            that.confirmLoading = true
            return cancelXsDetails({id:record.id,orderNo:record.orderNo, queryStatus:that.queryParam.status})
              .then(res => {
                if (res.code === '0') {
                  // that.$refs.table.refresh()
                  that.detailsList = res.data
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                that.confirmLoading = false
              })
          },
          onCancel() { }
        })
      },

      changeDetailsStatus(record){
        var that = this
        this.$confirm({
          title: '提示',
          content: '确定要关闭吗?',
          onOk() {
            that.confirmLoading = true
            return changeDetailsStatus({id:record.id, status: that.config.OrderStatus.FINISHED, orderNo:record.orderNo})
              .then(res => {
                if (res.code === '0') {
                  that.detailsList = res.data
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                that.confirmLoading = false
              })
          },
          onCancel() { }
        })
      },

      doCancelDetails(){
          this.visible.details = false
      },
      saveDetails(ele) {
        this.submitDetails(ele,this.config.OrderStatus.SAVED)
      },
      submitDetails(ele, status) {
        status = status || this.config.OrderStatus.WAIT_AUDIT
        this.detailsForm.validateFields((err, values) => {
          if (!err) {
            this.showLoading = true
            Object.assign(this.detailsMdl, values)
            this.detailsMdl.status = status
            this.detailsMdl.queryStatus = this.queryParam.status
            saveXsDetails(Object.assign({}, this.detailsMdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible.details = false
                  this.detailsList = res.data
                }
                this.detailsForm = this.$form.createForm(this)
              })
              .catch(e => {
                console.log(e)
              })
              .finally(res => {
                this.showLoading = false
            })
          }
        })
      },

      filterOption(input, option) {
        // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

      onChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      expandIcon(props){
       if(props.record.orderDetailsXsList.length > 0){
            if (props.expanded) {
                return <a style="color: 'black',margin-right:0px" onClick={e => {
                    props.onExpand(props.record, e);
                }}><a-icon type="caret-down" /></a>
            } else {
                return <a style="color: 'black' ,margin-right:0px" onClick={e => {
                    props.onExpand(props.record, e);
                }}><a-icon type="caret-right" /></a>
            }
        }else{
            return <span style="margin-right:0px"><a-icon type="smile" /></span>
        }
      },
    },
    watch: {}
  }
</script>

<style scoped>
  /deep/ .ant-form-item {
    margin-bottom: 10px;
  }
  /deep/ .wxf-input-suffix {
    right: 28px;
    position: absolute;
    top: 50%;
    z-index: 2;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    line-height: 0;
    color: rgba(0, 0, 0, 0.65);
  }
</style>